import { formatDate } from 'helpers';
import { i18n } from 'locales';
import fp from 'lodash/fp';

export const TABLE_HEADERS = [
  i18n.t('table.header.original_hash', { ns: 'pages:ccmds' }),
  i18n.t('table.header.hash', { ns: 'pages:ccmds' }),
  i18n.t('table.header.issuer', { ns: 'pages:ccmds' }),
  i18n.t('table.header.date', { ns: 'pages:ccmds' }),
];

export const truncateOriginalHash = fp.compose(
  fp.truncate({ length: 24 }),
  fp.get('original_hash'),
);

export const truncateHash = fp.compose(
  fp.truncate({ length: 24 }),
  fp.get('hash'),
);

export const getDateAndFormat = fp.compose(formatDate, fp.get('created_at'));
